import '../../partials/content/kalkulyator-it-autsorsinga/kalkulyator';
import '../../partials/content/kalkulyator-it-autsorsinga/kalkulyator-modal';
